export default "__VITE_ASSET__CGCPyfJl__"